<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .anonymize-settings {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);

    .title {
      @include mixins.body2();
      color: colors.get(black_90);
    }

    .checkboxes {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(8px);
      padding-left: utils.in_rem(8px);

      .checkbox {
        display: flex;
        align-items: flex-start;
        gap: utils.in_rem(8px);
      }
    }
  }
</style>

<script>
  import Checkbox from "@sourcewhale/shared/svelte-design-system/components/atoms/Checkbox/Checkbox.svelte";
  import Label from "@sourcewhale/shared/svelte-design-system/components/atoms/InputLabels/Label.svelte";
  import { getShareResumeContext } from "../context.svelte";

  const ctx = getShareResumeContext();
</script>

<div class="anonymize-settings">
  <span class="title">Anonymize</span>
  <div class="checkboxes">
    <div class="checkbox">
      <Checkbox bind:checked={ctx.hideContactInfo} />
      <Label label="Hide email addresses and phone numbers" labelSize="large" />
    </div>
    <div class="checkbox">
      <Checkbox bind:checked={ctx.hideName} />
      <Label label="Hide names" labelSize="large" />
    </div>
  </div>
</div>
